import CropSquareIcon from "@mui/icons-material/CropSquare";
import Crop32Icon from "@mui/icons-material/Crop32";
import Crop75Icon from "@mui/icons-material/Crop75";
import DownloadIcon from "@mui/icons-material/Download";

export const data = {
  subActions: [
    {
      name: "Aspect Ratio",
      muiIcon: "",
      subActions: [
        {
          name: "1:1",
          muiIcon: <CropSquareIcon fontSize="large" />,
          tooltip: "Ideal for Instagram collages",
          action: {
            descriptor: { MeXAR: "1:1" },
            type: "select",
          },
        },
        {
          name: "4:5",
          tooltip: "Ideal for Instagram posts and carousels",
          muiIcon: (
            <Crop75Icon fontSize="large" sx={{ transform: "rotate(90deg)" }} />
          ),
          action: {
            descriptor: { MeXAR: "4:5" },
            type: "select",
          },
        },
        {
          name: "9:16",
          tooltip: "Ideal for Instagram and TikTok stories",
          muiIcon: (
            <Crop32Icon fontSize="large" sx={{ transform: "rotate(90deg)" }} />
          ),
          action: {
            descriptor: { MeXAR: "9:16" },
            type: "select",
          },
        },
        {
          name: "16:9",
          muiIcon: <Crop32Icon fontSize="large" />,
          tooltip: "Ideal for websites",
          action: {
            descriptor: { MeXAR: "16:9" },
            type: "select",
          },
        },
      ],
    },
    {
      name: "Resolution",
      muiIcon: "",
      subActions: [
        {
          name: "1080 x 1080",
          action: {
            descriptor: { MeXRe: "1080x1080" },
            type: "select",
          },
        },
        {
          name: "2160 x 2160",
          action: {
            descriptor: { MeXRe: "2160x2160" },
            type: "select",
          },
        },
        {
          name: "1080 x 1350",
          action: {
            descriptor: { MeXRe: "1080x1350" },
            type: "select",
          },
        },
        {
          name: "2160 x 2700",
          action: {
            descriptor: { MeXRe: "2160x2700" },
            type: "select",
          },
        },
        {
          name: "1080 x 1920",
          action: {
            descriptor: { MeXRe: "1080x1920" },
            type: "select",
          },
        },
        {
          name: "2160 x 3840",
          action: {
            descriptor: { MeXRe: "2160x3840" },
            type: "select",
          },
        },
        {
          name: "1920 x 1080",
          action: {
            descriptor: { MeXRe: "1920x1080" },
            type: "select",
          },
        },
        {
          name: "3840 x 2160",
          action: {
            descriptor: { MeXRe: "3840x2160" },
            type: "select",
          },
        },
      ],
    },
    {
      name: "Export image",
      action: {
        type: "select",
      },
      subActions: [
        {
          name: "Export",
          muiIcon: <DownloadIcon fontSize="large" />,
          action: {
            descriptor: { CreateScreenshot: "export" },
            type: "select",
          },
        },
      ],
    },
  ],
};
